import { Navbar1 } from "components/navbars";
import { Hero12 } from "components/heros";
import { Footer1 } from "components/footer";
import Seo from "components/Seo";
import BackToTop from "components/BackToTop";
import Features1 from "crm/landings/Saas/Features1";
import { crmFeatures, features } from "crm/landings/Saas/data";
import { usePageTracking } from "helpers/usePageTracking";

export default function Home() {
    const seo = usePageTracking("home");
    return (
        <>
            {seo && (
                <Seo
                    pageName="home"
                    title={seo.pageTitle}
                    description={seo.seoMetaDescription}
                    keywords={seo.seoMetaKeywords}
                    url="https://salestrackify.com/"
                    image="/seo/trackify-preview.png"
                />
            )}
            <Navbar1
                hideSearch
                fixedWidth
                navClass="navbar-light zindex-10"
                buttonClass="btn-outline-secondary btn-sm"
            />
            <Hero12 />
            <Features1
                features={features}
                crmFeatures={crmFeatures}
                containerClass="position-relative overflow-hidden pt-lg-6 py-4 pb-lg-5"
            />
            <Footer1 />
            <BackToTop />
        </>
    );
}
